/* ============================================================================
   tiers-ui.js - shared subscription tier cards (2.0 layout, landing + profile)
   ============================================================================ */

import { SUBSCRIPTION_TIERS, KOFI_URL, isFirstCreditBonusActive } from "./sample-data.js?v=20261007m";
import { mapLegacyTierId } from "./subscription.js?v=20261007m";
import { jarImageSrc, tierFrameSrc } from "./asset-version.js?v=20261007m";

export { KOFI_URL, mapLegacyTierId };

/** Paid membership cards only. The Crumb is rendered with them in the same grid. */
export function paidSubscriptionTiers() {
  return SUBSCRIPTION_TIERS.filter((t) => t.id !== "free");
}

export function tierPerkLines(tier) {
  const lines = [];
  if (tier.kofiDiscount) lines.push(`Ko-fi discount: ${tier.kofiDiscount}`);
  // Credits sit in the card footer details, so skip them here.
  if (tier.overlayRequests) lines.push(`Overlay requests: ${tier.overlayRequests}`);
  if (tier.backgroundResizing) lines.push(`Background resizing: ${tier.backgroundResizing}`);
  if (tier.lottery) lines.push(`Monthly lottery: ${tier.lottery}`);
  if (tier.earlyLottery) lines.push(`Early lottery: ${tier.earlyLottery}`);
  for (const perk of tier.perks || []) {
    if (/first refill:\s*2×/i.test(perk) && !isFirstCreditBonusActive()) continue;
    lines.push(perk);
  }
  return lines;
}

function tierJarMarkup(tier) {
  const src = tier.id === "free" ? jarImageSrc("0") : tierFrameSrc(tier.id);
  if (!src) return "";
  return `<div class="tier-card__jar" aria-hidden="true"><img src="${src}" alt="" width="52" height="52" loading="lazy" decoding="async" /></div>`;
}

/** @param {HTMLElement} grid @param {string|null} currentTierId logged-in user's tier, or null on landing */
export function renderTierCards(grid, currentTierId = null, { featuredTierId = null } = {}) {
  if (!grid) return;

  const currentId = currentTierId != null ? mapLegacyTierId(currentTierId) : null;
  const mostLovedId = featuredTierId ? mapLegacyTierId(featuredTierId) : null;

  grid.innerHTML = SUBSCRIPTION_TIERS.map((tier) => {
    const isFree = tier.id === "free";
    const isCurrent = currentId != null && tier.id === currentId;
    const isMostLoved = mostLovedId && tier.id === mostLovedId;
    const featured = isMostLoved ? " tier-card--featured" : "";
    const current = isCurrent ? " tier-card--current" : "";
    const crumb = isFree ? " tier-card--free" : "";
    const perks = tierPerkLines(tier).map((p) => `<li>${p}</li>`).join("");
    const badge = isCurrent
      ? `<span class="tier-card__badge">Your tier</span>`
      : isFree
        ? `<span class="tier-card__badge">Always free</span>`
        : `<span class="tier-card__badge tier-card__badge--spacer" aria-hidden="true"></span>`;
    const showCtas = currentId == null;
    const cta = !showCtas
      ? ""
      : isFree
        ? `<a class="btn btn--primary btn--block" href="#join">Enter the jar</a>`
        : `<a class="btn btn--primary btn--block" href="${tier.kofi || KOFI_URL}" target="_blank" rel="noopener noreferrer">Join on Ko-fi</a>`;

    return `
      <article class="tier-card card${featured}${current}${crumb}">
        ${isMostLoved ? '<span class="tier-card__ribbon">Most loved</span>' : ""}
        <div class="tier-card__head">
          ${badge}
          ${tierJarMarkup(tier)}
          <p class="eyebrow">${tier.name}</p>
          <h3 class="tier-card__price">${tier.price}</h3>
        </div>
        <ul class="tier-card__perks">${perks}</ul>
        <dl class="tier-card__details">
          ${tier.vault ? `<div><dt>Monthly credits</dt><dd>${tier.vault}</dd></div>` : ""}
        </dl>
        ${cta ? `<div class="tier-card__cta">${cta}</div>` : `<div class="tier-card__cta" hidden></div>`}
      </article>`;
  }).join("");
}
